<template>
  <el-dialog title="Add Account" :width="dialogWidth" :visible.sync="visible" :close-on-click-modal="false">
    <div v-loading="form_loading">
      <div class="form">
        <div class="div">
          Email*
          <el-input class="margin-top-switch" placeholder="Email" v-model="account_obj.email"/>
        </div>

        <div class="div">
          Password*
          <el-input class="margin-top-switch" placeholder="Password" v-model="account_obj.password" type="password" maxlength="20"/>
        </div>

        <div class="div">
          Account type*
          <el-select class="margin-top-switch" v-model="account_obj.account_type" placeholder="Account type">
            <el-option label="Administrator" value="MAIN"></el-option>
            <el-option label="Standard User" value="REGULAR"></el-option>
          </el-select>
        </div>

      </div>
      <div class="dialog-footer" style="display: flex;justify-content: flex-end;">
        <el-button type="primary" size="small" @click="save_send" style="background-color: #5856D6;border-color:#5856D6;">Save</el-button>
      </div>
    </div>
  </el-dialog>

</template>

<script>
import Vue from 'vue';
import { getActionApi, postActionApi } from '@/network/manageApi';
export default {
  name: 'AddAccount',
  components: {},
  data() {
    return {
      dialogWidth:'600px',
      visible: false,
      account_obj: {},
      form_loading: false,
    }
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.setDialogWidth()
      })()
    }
  },
  created() {
    this.setDialogWidth()
  },
  methods: {
    init() {
      this.visible = true
      this.account_obj = {}
    },
    save_send() {
      if(!this.account_obj.email) {
        this.$message({
          message: 'Please enter email.',
          type: 'warning'
        });
        return;
      }
      if(!this.validateEmail(this.account_obj.email)) {
        this.$message({
          message: 'Please enter the correct e-mail.',
          type: 'warning'
        });
        return;
      }
      let param = {email: this.account_obj.email}
      if(!this.account_obj.password) {
        this.$message({
          message: 'Please enter password.',
          type: 'warning'
        });
        return;
      }
      if(this.account_obj.password.length < 8) {
        this.$message({
          message: 'Password must be at least 8 characters long',
          type: 'warning'
        });
        return;
      }
      param.password = this.account_obj.password
      if(!this.account_obj.account_type) {
        this.$message({
          message: 'Please enter select account type.',
          type: 'warning'
        });
        return;
      }
      param.account_type = this.account_obj.account_type
      this.form_loading = true
      postActionApi("/user-management/accounts", param).then((res) => {
        if(res.code == 201 || res.code == 200) {
          this.$emit('ok')
          this.$message.success({message: "Success"});
          this.visible = false
        }
      }).catch((err) => {
        this.$message.error({message: err.response.data.details.data.message});
      }).finally((res) => {
        this.form_loading = false
      })
    },
    validateEmail(email) {
      var emailRegex = /^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
      return emailRegex.test(email);
    },
    setDialogWidth() {
      var val = document.body.clientWidth
      const def = 600 // default width
      if (val < def) {
        this.dialogWidth = '100%'
      } else {
        this.dialogWidth = def + 'px'
      }
    }
  }
}
</script>

<style scoped>
  .form{display: flex;flex-direction: column;}
  .form .flex{display: grid;grid-template-columns:1fr 1fr;gap: 20px;padding-bottom: 0;}
  .form .div{display: flex;flex-direction: column;color:#A0ABC0;font-weight: bold;padding-bottom:20px;}
  .form .div input{border-radius: 6px;border:1px solid #E2E8F0;height:40px;padding:0 20px;margin-top:10px;}
  .form .div select{border-radius: 6px;border:1px solid #E2E8F0;height:40px;padding:0 20px;margin-top:10px;box-sizing: border-box;}
  .headImage{display: flex;width: 76px;margin-top:15px;}
  .headImage .edit{display: none;padding-bottom:0;width: 76px;height: 76px;position: absolute;justify-content: center;align-items: center;background-color: rgba(0, 0, 0, 0.5);border-radius: 4px;}
  .headImage .edit span{background-color: rgba(255, 255, 255, 0.36);margin-left:0;padding:4px 10px;border-radius:4px;font-weight: bold;color:#ffffff;cursor: pointer;}
  .headImage:hover .edit{display: flex;}
  .headImage img{width: 76px;height: 76px;border-radius: 4px;}
  .default_upload {width: 76px;height: 76px;border: 1px dashed #d9d9d9;border-radius: 6px;cursor: pointer;display: flex;align-items: center;justify-content: center;}
  .avatar-uploader-icon {font-size: 18px;color: #8c939d;}
  .font-size-16 {font-size: 16px;}
  .margin-top-switch {margin-top: 10px;}
</style>
